import { spec } from '@cxl/spec';
import { eventFired, startWorkspace, loadProject } from '../api/test-helper';
import { writeFile, unlink } from 'fs/promises';

declare const ide: any;

export default spec('server', s => {
	s.test('project', async s => {
		s.afterAll(await startWorkspace());
		s.test('rebuild files when new files are added or removed', async a => {
			const project = await loadProject('test-project');
			const spy = a.spyFn(project.files as any, 'buildFilesDebounced');
			const spy2 = a.spyFn(project.files as any, 'watchFiles');
			const newFile = `${ide.cwd}/${project.path}/test`;
			writeFile(newFile, 'test');
			const ev1 = eventFired('project.filechange');
			const ev = await spy;
			await ev1;
			await spy2;
			a.equal(ev.called, 1);

			// Should not reload on file change
			writeFile(newFile, 'test');
			await eventFired('project.filechange');
			a.equal(ev.called, 1);

			await unlink(newFile);
			const ev2 = await spy;
			a.equal(ev2.called, 2);
		});
	});
});
